let sidenav: HTMLElement | null = null;
let navContent: HTMLElement | null = null;
let navOverlay: HTMLElement | null = null;
let navLinks: HTMLElement | null = null;

function querySelecters() {
    if (!sidenav) sidenav = document.getElementById("mySidenav");
    if (!navContent) navContent = document.getElementById("nav-content");
    if (!navOverlay) navOverlay = document.getElementById("navOverlay");
    if (!navLinks) navLinks = document.getElementById("nav-links");
    return { sidenav, navContent, navOverlay, navLinks };
}

function onEsc(e: KeyboardEvent) {
    if (e.key === "Escape") closeNav();
}

export function openNav() {
    const { sidenav, navContent, navOverlay, navLinks } = querySelecters();
    if (!sidenav || !navOverlay) return;

    navOverlay.classList.remove("opacity-0", "pointer-events-none");
    navOverlay.classList.add("opacity-100");

    sidenav.classList.remove("w-0");
    sidenav.classList.add("w-[92%]", "lg:w-[92%]");
    sidenav.setAttribute("aria-hidden", "false");

    if (navContent) {
        navContent.classList.remove("opacity-0");
        navContent.classList.add("opacity-100", "delay-200");
    }
    if (navLinks) {
        navLinks.classList.remove("opacity-0");
        navLinks.classList.add("opacity-100", "delay-200");
    }

    document.addEventListener("keydown", onEsc);
    // (valgfrit) flyt fokus til close-knap, hvis du giver den id
    // document.getElementById('closeNavBtn')?.focus();
}

export function closeNav() {
    const { sidenav, navContent, navOverlay, navLinks } = querySelecters();
    if (!sidenav || !navOverlay) return;

    document.removeEventListener("keydown", onEsc);

    const menuButton = document.querySelector(".menuButton") as HTMLElement;
    menuButton?.focus();

    if (navContent) {
        navContent.classList.remove("opacity-100", "delay-200");
        navContent.classList.add("opacity-0");
    }
    if (navLinks) {
        navLinks.classList.remove("opacity-100", "delay-200");
        navLinks.classList.add("opacity-0");
    }

    let hasClosed = false;
    const done = () => {
        if (hasClosed) return;
        hasClosed = true;

        sidenav.classList.remove("w-[92%]", "lg:w-[92%]");
        sidenav.classList.add("w-0");
        sidenav.setAttribute("aria-hidden", "true");

        navOverlay.classList.remove("opacity-100");
        navOverlay.classList.add("opacity-0", "pointer-events-none");

        navContent?.removeEventListener("transitionend", done);
        navLinks?.removeEventListener("transitionend", done);
    };

    navContent?.addEventListener("transitionend", done, { once: true });
    navLinks?.addEventListener("transitionend", done, { once: true });
    setTimeout(done, 250);
}

declare global {
    interface Window {
        openNav: () => void;
        closeNav: () => void;
    }
}
(window as any).openNav = openNav;
(window as any).closeNav = closeNav;
